module.exports = __webpack_public_path__ + "img/mifune_raigeki.efe17858.png";